import apiRequest from './apiRequest';

const plApi = {

    createProfiteAndLoss(plData,accountId, token) {
        return apiRequest(`/api/profit-and-loss/sheet?accountId=${encodeURIComponent(accountId)}`, 'POST', token, plData);
    },

    updateProfiteAndLoss(id, token, plData) {
        return apiRequest(`/api/profit-and-loss/${id}`, 'PUT', token, plData);
    },


    // getAllProfiteAndLoss(token) {
    //     return apiRequest('/api/profit-and-loss/all', 'GET', token);
    // },

    //  deleteProfiteAndLoss(id, token) {
    //     return apiRequest(`/api/profit-and-loss/${id}`, 'DELETE', token);
    // }, 

    // getProfiteAndLossById(id, token) {
    //     return apiRequest(`/api/profit-and-loss/${id}`, 'GET', token);
    // },

    //  getProfiteAndLossMonthWise(token, companyName, start, end) {
    //     const url = `/api/profit-and-loss/month-wise?companyName=${encodeURIComponent(companyName)}&startDate=${start}&endDate=${end}`;
    //     return apiRequest(url, 'GET', token);
    // },
    getProfiteAndLossMonthWise(token, companyName, start, end) {
  const url = `/api/profit-and-loss/month-wise?accountId=${encodeURIComponent(companyName)}&startDate=${start}&endDate=${end}`;
  return apiRequest(url, 'GET', token);
},
    getProfiteAndLossOneMonth(token, companyName, start) {
  const url = `/api/profit-and-loss/one-month/details?accountId=${encodeURIComponent(companyName)}&startDate=${start}`;
  return apiRequest(url, 'GET', token);
},

    getProfiteAndLossFOrecastReport(companyName, forecastMonth,token) {
  const url = `/api/profit-and-loss/forecast-report?accountId=${encodeURIComponent(companyName)}&forecastMonths=${forecastMonth}`;
  return apiRequest(url, 'GET', token);
},

 
};

export default plApi;
